import TrustList from './TrustList.vue'

export default TrustList
